module.exports = [{"name":"ContinueButton","label":"SAVE & RUN CARRIER RESULTS","status":"Enabled","type":"Continue","on_click":"/pages/HORateCall2Details/","action":"POST","routeTo":"hodwelling","pageName":null}]


//////////////////
// WEBPACK FOOTER
// ./config/admin/continueButton.json
// module id = v/Hb
// module chunks = 2